<template>
	<!-- 编辑界面 -->
	<el-drawer :visible.sync="editFormVisible" :title="title" :size="600" :wrapper-closable="false" :modal="false" :destroy-on-close="true" class="margin_top_40" @click="closeDialog">
		<el-form ref="editForm" label-width="8.75rem" :model="editForm" :rules="rules">
			<el-form-item label="类型名称" prop="typeName">
				<el-input v-model="editForm.productInfo.typeName" placeholder="请输入类型名称" size="small" class="input_200px" disabled />
			</el-form-item>
			<el-form-item label="商品名称" prop="productName">
				<el-input v-model="editForm.productInfo.productName" placeholder="请输入商品名称" size="small" class="input_200px" disabled />
			</el-form-item>
			<el-form-item label="规格" prop="specification">
				<el-input v-model="editForm.productInfo.specification" placeholder="请输入规格" size="small" class="input_200px" disabled />
			</el-form-item>
			<el-form-item label="单位" prop="unit">
				<el-input v-model="editForm.productInfo.unit" placeholder="请输入单位" size="small" class="input_200px" disabled />
			</el-form-item>
			<el-form-item label="数量" prop="quantity">
				<el-input-number v-model.number="editForm.quantity" :min="0" :step="1" :precision="0" placeholder="请输入数量" size="small" class="input_200px" />
			</el-form-item>
			<el-form-item label="价格(元)" prop="price">
				<el-input-number v-model.number="editForm.price" :min="0" :step="0.01" :precision="2" placeholder="请输入价格(元)" size="small" class="input_200px" />
			</el-form-item>
			<el-form-item v-if="canSeeCost" label="成本金额(元)" prop="costMoney">
				<el-input-number v-model.number="editForm.costMoney" :min="0" :step="0.01" :precision="2" placeholder="请输入成本金额(元)" size="small" class="input_200px" />
			</el-form-item>
			<el-form-item label="生产日期" prop="productDate">
				<el-date-picker v-model="editForm.productDate" type="date" value-format="yyyy-MM-dd" placeholder="请选择生产日期" size="small" class="input_200px" />
			</el-form-item>
			<el-form-item label="过期日期" prop="expireDate">
				<el-date-picker v-model="editForm.expireDate" type="date" value-format="yyyy-MM-dd" placeholder="请选择过期日期" size="small" class="input_200px" />
			</el-form-item>
			<el-form-item label="备注" prop="remark">
				<el-input v-model="editForm.remark" placeholder="请输入备注" size="small" class="input_200px" type="textarea" rows="4" />
			</el-form-item>
		</el-form>
		<div class="drawer-footer">
			<el-button size="small" icon="el-icon-check" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
		</div>
	</el-drawer>
</template>

<script>
import costPermission from "@/utils/costPermission.js";
import { SaveInputStoreProduct, GetStoreProductDetail } from "@/api/productApi.js";
export default {
	mixins: [costPermission],
	data() {
		return {
			title: "",
			loading: false, //是显示加载
			editFormVisible: false, //控制编辑页面显示与隐藏
			editForm: {
				keyId: "",
				storeProductKeyId: "",
				productInfo: {},
				quantity: 0,
				price: 0,
				costMoney: 0,
				productDate: null,
				expireDate: null,
				remark: ""
			},
			// rules 表单验证
			rules: {
				quantity: [
					{ required: true, message: "请输入数量", trigger: "blur" },
					{ type: "number", message: "请输入数字", trigger: "blur" }
				],
				price: [
					{ required: true, message: "请输入价格", trigger: "blur" },
					{ type: "number", message: "请输入数字", trigger: "blur" }
				],
				costMoney: [
					{ required: true, message: "请输入成本金额", trigger: "blur" },
					{ type: "number", message: "请输入数字", trigger: "blur" }
				]
			}
		};
	},
	computed: {},
	watch: {},
	created() {},
	mounted() {},
	components: {},
	methods: {
		//显示编辑界面
		editShow(row) {
			this.editForm = {
				keyId: "",
				storeProductKeyId: "",
				productInfo: {},
				quantity: 0,
				price: 0,
				productDate: null,
				expireDate: null,
				remark: ""
			};
			if (row != undefined && row != "undefined" && row.keyId != undefined && row.keyId != "undefined") {
				this.title = "编辑";
				let parmer = {
					keyId: row.keyId
				};
				GetStoreProductDetail(parmer)
					.then((res) => {
						if (res.code == 1) {
							this.editForm.productInfo = res.data.productInfo;
							this.editForm.storeProductKeyId = row.keyId;
							this.editForm.price = res.data.price;
							this.editFormVisible = true;
						} else {
							this.$message.error(res.msg);
						}
					})
					.catch((err) => {
						this.$message.error("获取门店入库单详情失败!");
					});
			} else {
				this.$message.error("请先选择商品！");
			}
		},
		// 编辑、增加页面保存方法
		submitForm(editData) {
			this.$refs[editData].validate((valid) => {
				if (valid) {
					SaveInputStoreProduct(this.editForm)
						.then((res) => {
							if (res.code == 1) {
								this.$parent.getListData();
								this.$message({
									type: "success",
									message: "门店入库单保存成功！"
								});
								this.editFormVisible = false;
								this.loading = false;
							} else {
								this.$message({
									type: "info",
									message: res.msg
								});
							}
						})
						.catch((err) => {
							this.editFormVisible = false;
							this.loading = false;
							this.$message.error("门店入库单保存失败，请稍后再试！");
						});
				} else {
					return false;
				}
			});
		},
		// 关闭编辑、增加弹出框
		closeDialog() {
			this.editFormVisible = false;
			this.$data.editForm = this.$options.data.call(this).editForm;
		}
	}
};
</script>
<style scoped>
.wip {
	width: 200px !important;
}
</style>
